import _get from 'lodash/get';
import getExperimentsList from './getExperimentList';
export default function processPersonalizationResponse(response) {
  const personalization = {};
  const sources = _get(response, 'sources', []);

  // locate the correct sources from the sources array
  const experimentSource = sources.find(_ref => {
    let {
      source
    } = _ref;
    return source === 'activeExperiments';
  });
  const consumerAdTargetsSource = sources.find(_ref2 => {
    let {
      source
    } = _ref2;
    return source === 'consumerAdTargets';
  });
  const consumerCampaignPreferencesSource = sources.find(_ref3 => {
    let {
      source
    } = _ref3;
    return source === 'consumerCampaignPreferences';
  });
  const consumerInsightsSource = sources.find(_ref4 => {
    let {
      source
    } = _ref4;
    return source === 'consumerInsights';
  });
  const consumerAdTargetsWithoutCAMPBiasSource = sources.find(_ref5 => {
    let {
      source
    } = _ref5;
    return source === 'consumerAdTargetsWithoutCAMPBias';
  });
  const consumerMarketingSegmentsSource = sources.find(_ref6 => {
    let {
      source
    } = _ref6;
    return source === 'consumerMarketingSegments';
  });
  const peActiveExperiments = _get(experimentSource, 'derived.experiments', null);
  const consumerAdTargets = _get(consumerAdTargetsSource, 'derived', {});
  const consumerInsights = _get(consumerInsightsSource, 'derived.insightsByCatalog[0].insights.rawInsights', null);
  const consumerCampaignPreferences = _get(consumerCampaignPreferencesSource, 'derived', null);
  const insightsTrackingId = _get(consumerInsightsSource, 'raw.metadata.trackingId', null);
  const consumerAdTargetsWithoutCAMPBias = _get(consumerAdTargetsWithoutCAMPBiasSource, 'derived', {});
  const consumerMarketingSegments = _get(consumerMarketingSegmentsSource, 'raw', {});
  if (consumerInsights) {
    Object.assign(personalization, {
      trackingId: insightsTrackingId,
      ...consumerInsights
    });
  }
  return {
    personalization,
    experiments: peActiveExperiments && getExperimentsList(peActiveExperiments),
    preferences: {
      topRankedVehicle: _get(consumerCampaignPreferences, 'rankedVehicles.vehicles[0]', {
        addedByRule: 'INCONCLUSIVE'
      })
    },
    consumerAdTargets,
    consumerAdTargetsWithoutCAMPBias,
    consumerMarketingSegments
  };
}